const features = [
  {
    icon: 'ri-shield-check-line',
    title: '官方正版认证',
    description: '所有游戏均经过官方授权认证，杜绝盗版和恶意软件，保障您的设备和数据安全。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速下载体验',
    description: '采用CDN加速技术，多节点智能分发，确保全国用户都能享受高速下载服务。',
  },
  {
    icon: 'ri-device-line',
    title: '全平台兼容',
    description: '完美适配iOS、Android及PC多平台设备，一套账号畅玩所有终端。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '7×24小时客服',
    description: '专业客服团队全天候在线，快速响应您的问题，提供贴心的售后服务。',
  },
  {
    icon: 'ri-lock-line',
    title: '账号安全保障',
    description: '多重加密技术与实名认证体系，全方位守护您的账号安全和游戏资产。',
  },
  {
    icon: 'ri-gift-line',
    title: '丰富福利活动',
    description: '新用户专享礼包、每日签到奖励、节日限定活动，让游戏体验更加超值。',
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            为什么选择<strong className="text-primary-500">NG南宫</strong>？
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            我们致力于为玩家提供最安全、最便捷、最优质的游戏下载体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group p-6 rounded-lg bg-background-100 hover:bg-primary-50/50 transition-colors duration-200 cursor-default"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-200">
                <i className={`${feature.icon} text-lg`}></i>
              </div>
              <h3 className="font-heading text-base text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}